import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import Cin7CredentialsStore from "../../../stores/credentials/cin7-credentials-store";

interface IIntegrationProps {
    credentialsStore: Cin7CredentialsStore,
    vGroup: IValidationGroup,
}

const Cin7Credentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine
                label='API key'
                note='Your Cin7 API key'
                required
                key='apiKey'
            >
                <Input
                    value={credentialsStore.api_key}
                    placeholder=''
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='API username'
                note='Your cin7 API username'
                required
                key='apiUsername'
            >
                <Input
                    value={credentialsStore.api_username}
                    placeholder=''
                    onChange={v => credentialsStore.api_username = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default Cin7Credentials;
